/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SelectComparablePropertyCoverImageRequestDto
 */
export interface SelectComparablePropertyCoverImageRequestDto {
    /**
     * 
     * @type {number}
     * @memberof SelectComparablePropertyCoverImageRequestDto
     */
    properyImageId: number;
}

/**
 * Check if a given object implements the SelectComparablePropertyCoverImageRequestDto interface.
 */
export function instanceOfSelectComparablePropertyCoverImageRequestDto(value: object): value is SelectComparablePropertyCoverImageRequestDto {
    if (!('properyImageId' in value) || value['properyImageId'] === undefined) return false;
    return true;
}

export function SelectComparablePropertyCoverImageRequestDtoFromJSON(json: any): SelectComparablePropertyCoverImageRequestDto {
    return SelectComparablePropertyCoverImageRequestDtoFromJSONTyped(json, false);
}

export function SelectComparablePropertyCoverImageRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectComparablePropertyCoverImageRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'properyImageId': json['properyImageId'],
    };
}

export function SelectComparablePropertyCoverImageRequestDtoToJSON(json: any): SelectComparablePropertyCoverImageRequestDto {
    return SelectComparablePropertyCoverImageRequestDtoToJSONTyped(json, false);
}

export function SelectComparablePropertyCoverImageRequestDtoToJSONTyped(value?: SelectComparablePropertyCoverImageRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'properyImageId': value['properyImageId'],
    };
}

